import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { dto_Customer } from "../../../../classes/dto-customer";

export const InvoiceTemplate = (
  GUNO,
  DeliveryDate,
  items,
  SubTotal,
  DisplayDiscount,
  TotalServiceCharge,
  DeliveryCharges,
  TotalTax,
  GrandTotal,
) => {
  let x =
    `<html lang="en">
      <head>
        <meta charset="utf-8">
        <style>
          .clearfix:after {
            content: "";
            display: table;
            clear: both;
          }

          a {
            color: #0087C3;
            text-decoration: none;
          }

          body {
            padding-right: 15px;
            padding-left: 15px;
            position: relative;
            width: 21cm;
            height: 100%;
            margin: 0 auto;
            color: #555555;
            background: #FFFFFF;
            font-family: Arial, sans-serif;
            font-size: 14px;
            font-family: SourceSansPro;
          }

          header {
            padding: 10px 0;
            margin-bottom: 20px;
            border-bottom: 1px solid #AAAAAA;
          }

          #logo {
            float: left;
            margin-top: 8px;
          }

          #logo img {
            height: 70px;
          }

          #company {
            float: right;
            text-align: right;
          }

          #details {
            margin-bottom: 50px;
          }

          #client {
            padding-left: 6px;
            border-left: 6px solid #0087C3;
            float: left;
          }

          #client .to {
            color: #777777;
          }

          h2.name {
            font-size: 1.4em;
            font-weight: normal;
            margin: 0;
          }

          #invoice {
            float: right;
            text-align: right;
          }

          #invoice h1 {
            color: #0087C3;
            font-size: 2.4em;
            line-height: 1em;
            font-weight: normal;
            margin: 0 0 10px 0;
          }

          #invoice .date {
            font-size: 1.1em;
            color: #777777;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            margin-bottom: 20px;
            background: #D3D3D3;
            width: 100%;
            border: 1px solid black;
          }

          table.main th,
          table.main td {
            text-align: center;
          }

          table.main th {
            padding: 20px;
            white-space: nowrap;
            background: #000000;
            color: #ffffff;
            font-weight: normal;
          }

          table.main td h4 {
            font-size: 1.2em;
            font-weight: normal;
          }

          table.main tbody tr:nth-child(even) {
            background-color: white;
            color: black;
          }

          #thanks {
            font-size: 2em;
            margin-bottom: 50px;
          }

          #notices {
            padding-left: 6px;
            border-left: 6px solid #0087C3;
          }

          table.main tr,
          table.main td{
            padding: -15px;
          }

          #notices .notice {
            font-size: 1.2em;
          }

          #Currency {
            font-size: larger;
            color: grey;
            margin-bottom: 5px;
          }

          table.secondary tr{
            font-weight: bold; 
            color: black; 
            text-align: left; p
            adding-bottom: 5px;
          }

          table.secondary{
            max-width: 290px; 
            margin-left: 420px; 
            border: none; 
            background-color: transparent;
          }

          span{
            font-size: 20px;
          }

          .special{
            padding-top: 15px;
            padding-bottom: 15px;
          }

        </style>

        <title>Avas Food INVOICE</title>
        <link rel="stylesheet" href="style.css" media="all" />
      </head>

      <body>
        <header class='clearfix'>
          <div id="logo">
            <img src="https://lh3.googleusercontent.com/AO62aeIxwOHKEYP_Ww3-XFlsKdsfkhk2-73_MRqxNCMhiybL2Pzh8SggWvYhudnLnBaF">
          </div>
          <div id="company">
            <h2 class="name">Avas Food</h2>
            <div>Ground Floor, H.Neeloafaru Hiya,Buruzu Magu, Male, Maldives</div>
            <div>` + dto_StartupPageLoadInfo.ContactUs + `</div>
            <div> <a href="mailto:accounts@avasfood.mv">accounts@avasfood.mv</a></div>
          </div>
        </header>

        <main>
          <div id="details" class="clearfix">
            <div id="client">
              <div class="to">INVOICE TO : </div>
              <h2 class="name">` + dto_Customer.CusName + `</h2>
              <div class="email"><a>` + dto_Customer.PhoneNo + `</a></div>
              <br/>
            </div>

            <div id="invoice">
              <h1>INVOICE`  + GUNO + `</h1>
              <div class="date">Date of Invoice : `  + DeliveryDate + `</div>
              <div class="date">TIN - 1107337GST501</div>
            </div>
          </div>

          <div id="Currency"> 
            <div> <h2>Currency :  ${dto_StartupPageLoadInfo.Currency} </h2></div>
          </div>

          </div>
            <table class="main" border="0" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>DESCRIPTION</th>
                  <th>U. PRICE</th>
                  <th>U. DISCOUNT</th>
                  <th>QTY</th>
                  <th>TOTAL PRICE</th>
                </tr>
              </thead>
              <tbody> `;

            for (let i = 0; i < items.length; i++) {
              x +=
              ` <tr>
                  <td>${i + 1}</td>
                  <td class="special"><span>${items[i].Desc}</span></td>
                  <td>${items[i].UP}</td>
                  <td>${items[i].UD}</td>
                  <td>${items[i].Qty}</td>
                  <td>${items[i].Total}</td>
                </tr>`
                ;
            }
   x += `     </tbody>
            </table>
            <table class="secondary">
              <tbody>
                <tr>
                  <td>SUBTOTAL</td>
                  <td>` + SubTotal + `</td>
                </tr>
                <tr>
                  <td>DISCOUNT</td>
                  <td> `+ DisplayDiscount + `</td>
                </tr>
                <tr>
                  <td>SERVICE CHARGE</td>
                  <td>` + TotalServiceCharge + `</td>
                </tr>
                <tr>
                  <td>DELIVERY CHARGE</td>
                  <td>` + DeliveryCharges + `</td>
                </tr>
                <tr>
                  <td>GST</td>
                  <td> `+ TotalTax + `</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>` + GrandTotal + `</td>
                </tr>
              </tbody>
            </table>
          <div id="thanks">Thank you!</div>
        </main>
      </body>
    </html>`

  return x;
}